import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { Icon } from 'antd';
import {
  Container,
  TemplateConatiner,
  EmptySettingsDetails,
  LoaderContainer,
  TemplateWrapper,
} from './styles';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import Loader from '../../components/Loader';
import LockStatusCheckModal from '../../components/Modals/LockStatusCheckModal';

// app store context API
import { AppStoreContext } from '../../context/appStoreContext';
import { INTERACTIVE_TEMPLATES_LIST } from './translationValues';
import { useTranslation } from 'react-i18next';
import { CREATE_NEW_TEMPLATE_MODAL } from '../../components/CreateNewTemplate/translationValues';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';
import { fetchPlanUsageDetails } from '../../utils/services/planUsage';
import { SUPPORT_EMAIL_ID, checkSessionUserAccess, ENTERPRISE_ENV } from '../../utils/helper';
import { useSessionContext } from '../../context/sessionContext';
import InteractiveTemplate from './interactiveTemplate';

const NAMESPACES = ['INTERACTIVE_TEMPLATES_LIST'];

const InteractiveTemplates = props => {
  const { categoryList, templatesList, fetchingCategories, totalTemplates } = props;
  const { t } = useTranslation(NAMESPACES);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const { loginVisible, setLoginVisible } = useContext(AppStoreContext);
  const [lockedBy, setLockedBy] = useState({});
  const history = useHistory();

  const [documentLimit, setDocumentLimit] = useState(null);
  const [planName, setPlanName] = useState('');
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const sessionSelector = useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);

  useEffect(() => {
    if (
      loginVisible === false &&
      Boolean(selectedTemplate) &&
      Boolean(selectedTemplate.id) &&
      !Boolean(selectedAction)
    ) {
      history.push(`/interactiveDesign/${selectedTemplate.encodedId}`);
    }
  }, [loginVisible, selectedTemplate, selectedAction, history]);

  const enableModalVisibility = async (actionType, template) => {

    if(ENTERPRISE_ENV || checkSessionUserAccess(userDetails, 'master')) {
      setUpdateModalVisibility(true);
      setSelectedAction(actionType);
      setSelectedTemplate(template);
      return;
    }
    try {    
      const response = await fetchPlanUsageDetails();
      if(response?.statusCode === 1918) {
        const { templateLimit: created } = response.data.usage;
        const { templateLimit: limit, planName } = response.data.upperLimit;
        console.log({limit:limit})
        console.log({created:created})
        if (created >= limit) {
          setDocumentLimit(limit);
          setPlanName(planName);
          setShowUpgradeModal(true);
        } else {
          setUpdateModalVisibility(true);
          setSelectedAction(actionType);
          setSelectedTemplate(template);
        }
      }
    }
    catch(e) {
      console.error(e);
    }
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setSelectedAction(null);
    setSelectedTemplate(null);
  };

  const redirectToMailTemplate = template => {
    if(template.encodedId) {
      history.push(`/interactiveDesign/${template.encodedId}`);
    }
  };

  const renderBody = (categoriesTemp, templatesList) => {
    return (
      <React.Fragment>
        {templatesList.length > 0 && (
          <>
            <TemplateWrapper>
              {templatesList.map(templateObj => {
                return (
                  <InteractiveTemplate
                    key={templateObj.encodedId}
                    templateObj={templateObj}
                    categoriesTemp={categoriesTemp}
                    redirectToTemplate={redirectToMailTemplate}
                    enableModalVisibility={enableModalVisibility}
                  />
                );
              })}
            </TemplateWrapper>
          </>
        )}
      </React.Fragment>
    );
  };

  return (
    <>
      <Container>
        {fetchingCategories ? (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        ) : (
          <TemplateConatiner>
            <>{totalTemplates === 0 ? '' : renderBody(categoryList, templatesList)}</>
            {!fetchingCategories &&
              updateModalVisibility &&
              !loginVisible &&
              selectedAction &&
              selectedAction === 'template-locked' && (
                <LockStatusCheckModal
                  visible={updateModalVisibility}
                  lockedBy={lockedBy}
                  onCancel={disableModalVisibility}
                />
              )}
            {templatesList.length !== 0 && (
              <>                
                {templatesList.length !== totalTemplates ? (
                  <div className="addMore">
                    <Icon type="loading" />
                    {t(
                      INTERACTIVE_TEMPLATES_LIST.LOADING_MORE.key,
                      INTERACTIVE_TEMPLATES_LIST.LOADING_MORE.value,
                    )}
                  </div>
                ) : (
                  <div className="allData">
                    {t(
                      INTERACTIVE_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.key,
                      INTERACTIVE_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.value,
                    )}
                  </div>
                )}
              </>
            )}
          </TemplateConatiner>
        )}
        {!fetchingCategories && templatesList.length === 0 && (
          <EmptySettingsDetails>
            <div className="empty-illustration">
              <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
            </div>
            <div className="empty-txt" style={{ color: 'black' }}>
              <span>
                {t(
                  INTERACTIVE_TEMPLATES_LIST.EMPTY_TEMPLATES_LIST.key,
                  INTERACTIVE_TEMPLATES_LIST.EMPTY_TEMPLATES_LIST.value,
                )}
              </span>
            </div>
          </EmptySettingsDetails>
        )}
        <UpgradePlanModal
          visible={showUpgradeModal}
          modalText={
            planName === 'Premium' ?
              t(CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.key, CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.value, { emailId: SUPPORT_EMAIL_ID })
              : planName === 'Free' ? t(CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.value, { documentLimit })
                : t(CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.value, { documentLimit })
          }
          onCancel={() => setShowUpgradeModal(false)}
        />
      </Container>
    </>
  );
};

export default InteractiveTemplates;
